export default __webpack_public_path__ + "static/media/haproxy.5f8fb52a.svg";